(function () {
  'use strict';

  function formatRand(amount) {
    var n = Math.round(amount * 100) / 100;
    return 'R' + n.toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  document.querySelectorAll('[data-hosp-pricing]').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hosp-card]'));
    var summary = root.querySelector('[data-hosp-summary]');
    var cartBox = summary.querySelector('[data-hosp-cart-box]');
    var cartItemsEl = summary.querySelector('[data-hosp-cart-items]');
    var totalLineEl = summary.querySelector('[data-hosp-total-line]');
    var checkoutBtn = summary.querySelector('[data-hosp-checkout]');
    var stickyBar = document.querySelector('[data-hosp-sticky-bar]');
    var stickyTotalEl = stickyBar ? stickyBar.querySelector('[data-hosp-sticky-total]') : null;
    var stickyCheckoutBtn = stickyBar ? stickyBar.querySelector('[data-hosp-sticky-checkout]') : null;

    // cart: array of { variantId, productTitle, variantTitle, price, compareAt, qty }
    var cart = [];

    var cardData = cards.map(function (card) {
      var variants = [];
      try {
        variants = JSON.parse(card.dataset.variants || '[]');
      } catch (e) {
        variants = [];
      }
      return {
        el: card,
        productTitle: card.dataset.productTitle || '',
        variants: variants,
        select: card.querySelector('[data-hosp-variant-select]'),
        addBtn: card.querySelector('[data-hosp-add-btn]'),
        priceEl: card.querySelector('[data-hosp-price]'),
        compareEl: card.querySelector('[data-hosp-compare]'),
        stitchEl: card.querySelector('[data-hosp-stitch-amount]')
      };
    });

    function getSelectedVariant(cd) {
      if (!cd.select) return null;
      var id = cd.select.value;
      for (var i = 0; i < cd.variants.length; i++) {
        if (String(cd.variants[i].id) === String(id)) return cd.variants[i];
      }
      return cd.variants[0] || null;
    }

    function updateCardDisplay(cd) {
      var variant = getSelectedVariant(cd);
      if (!variant) return;
      var price = (parseFloat(variant.price) || 0) / 100;
      var compareAt = (parseFloat(variant.compare_at_price) || 0) / 100;
      var hasDiscount = compareAt > price;

      if (cd.priceEl) cd.priceEl.textContent = formatRand(price);
      if (cd.compareEl) {
        if (hasDiscount) {
          cd.compareEl.textContent = formatRand(compareAt);
          cd.compareEl.hidden = false;
        } else {
          cd.compareEl.hidden = true;
        }
      }
      if (cd.stitchEl) cd.stitchEl.textContent = formatRand(price / 6);
    }

    function findCartLine(variantId) {
      for (var i = 0; i < cart.length; i++) {
        if (String(cart[i].variantId) === String(variantId)) return cart[i];
      }
      return null;
    }

    function addToCart(cd) {
      var variant = getSelectedVariant(cd);
      if (!variant || !variant.available) return;
      var price = (parseFloat(variant.price) || 0) / 100;
      var compareAt = (parseFloat(variant.compare_at_price) || 0) / 100;

      var line = findCartLine(variant.id);
      if (line) {
        line.qty += 1;
      } else {
        cart.push({
          variantId: variant.id,
          productTitle: cd.productTitle,
          variantTitle: variant.title,
          price: price,
          compareAt: compareAt,
          qty: 1
        });
      }

      renderCart();

      if (cd.addBtn) {
        var original = 'Add to Cart';
        cd.addBtn.textContent = 'Added ✓';
        cd.addBtn.setAttribute('data-added', 'true');
        clearTimeout(cd.addBtn._resetTimer);
        cd.addBtn._resetTimer = setTimeout(function () {
          cd.addBtn.textContent = original;
          cd.addBtn.removeAttribute('data-added');
        }, 1100);
      }
    }

    function changeLineQty(variantId, delta) {
      var line = findCartLine(variantId);
      if (!line) return;
      line.qty += delta;
      if (line.qty <= 0) {
        cart = cart.filter(function (l) { return l !== line; });
      }
      renderCart();
    }

    function removeLine(variantId) {
      cart = cart.filter(function (l) { return String(l.variantId) !== String(variantId); });
      renderCart();
    }

    function renderCart() {
      cartItemsEl.innerHTML = '';

      if (cart.length === 0) {
        cartBox.hidden = true;
        totalLineEl.textContent = 'Choose a size above and add it to your order.';
        checkoutBtn.disabled = true;
        if (stickyBar) stickyBar.hidden = true;
        return;
      }

      cartBox.hidden = false;

      var totalBeds = 0;
      var totalPrice = 0;
      var totalSavings = 0;

      cart.forEach(function (line) {
        totalBeds += line.qty;
        totalPrice += line.price * line.qty;
        if (line.compareAt > line.price) totalSavings += (line.compareAt - line.price) * line.qty;

        var row = document.createElement('div');
        row.className = 'hosp-cart-item';
        row.innerHTML =
          '<div class="hosp-cart-item__info">' +
            '<span class="hosp-cart-item__name">' + line.productTitle + ' — ' + line.variantTitle + '</span>' +
            '<span class="hosp-cart-item__price">' + formatRand(line.price) + ' each</span>' +
          '</div>' +
          '<div class="hosp-cart-item__qty">' +
            '<button type="button" class="hosp-cart-item__qty-btn" data-line-minus aria-label="Decrease quantity">-</button>' +
            '<span class="hosp-cart-item__qty-val">' + line.qty + '</span>' +
            '<button type="button" class="hosp-cart-item__qty-btn" data-line-plus aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="hosp-cart-item__remove" data-line-remove aria-label="Remove item">&times;</button>';

        row.querySelector('[data-line-minus]').addEventListener('click', function () { changeLineQty(line.variantId, -1); });
        row.querySelector('[data-line-plus]').addEventListener('click', function () { changeLineQty(line.variantId, 1); });
        row.querySelector('[data-line-remove]').addEventListener('click', function () { removeLine(line.variantId); });

        cartItemsEl.appendChild(row);
      });

      var summaryText = totalBeds + (totalBeds === 1 ? ' bed' : ' beds') + ' = ' + formatRand(totalPrice);
      if (totalSavings > 0) {
        summaryText += '. <span class="hosp-pricing__savings">You save ' + formatRand(totalSavings) + '.</span>';
      } else {
        summaryText += '.';
      }
      totalLineEl.innerHTML = summaryText;
      checkoutBtn.disabled = false;

      if (stickyBar) {
        stickyBar.hidden = false;
        if (stickyTotalEl) stickyTotalEl.textContent = totalBeds + (totalBeds === 1 ? ' bed' : ' beds') + ' = ' + formatRand(totalPrice);
      }
    }

    function checkout() {
      if (cart.length === 0) return;
      var items = cart.map(function (line) {
        return { id: line.variantId, quantity: line.qty };
      });

      [checkoutBtn, stickyCheckoutBtn].forEach(function (btn) {
        if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          [checkoutBtn, stickyCheckoutBtn].forEach(function (btn) {
            if (btn) { btn.disabled = false; btn.textContent = 'Checkout'; }
          });
          alert('Something went wrong adding these to your cart. Please try again.');
        });
    }

    cardData.forEach(function (cd) {
      updateCardDisplay(cd);

      if (cd.select) {
        cd.select.addEventListener('change', function () {
          updateCardDisplay(cd);
        });
      }
      if (cd.addBtn) {
        cd.addBtn.addEventListener('click', function () { addToCart(cd); });
      }
    });

    if (checkoutBtn) checkoutBtn.addEventListener('click', checkout);
    if (stickyCheckoutBtn) stickyCheckoutBtn.addEventListener('click', checkout);

    renderCart();
  });
})();
